import React from 'react'

import { useAppState } from '../../hooks/useAppState'
import useSubscriptionsQuery from '../../hooks/useSubscriptionsQuery'
import RqRoadmapBanner from './RqRoadmapBanner'
import SubscriptionExpiringBanner from './SubscriptionExpiringBanner'

const Banners: React.FC = () => {
  const { hasInteractedWithRqRoadmapBanner } = useAppState()
  const subscriptions = useSubscriptionsQuery().data

  const hasExpiringSubscriptions = subscriptions.some(
    (subscription) =>
      (subscription.expiringSoon &&
        !subscription.expiringSoonBannerDismissed) ||
      (subscription.expiringUrgently &&
        !subscription.expiringUrgentlyBannerDismissed),
  )

  /**
   * Return an array of banners in order of importance.
   * We only display the first one, so the order is important.
   */
  function getBanners() {
    const banners: React.ReactNode[] = []

    // Very important - we want them to get in touch ASAP
    if (hasExpiringSubscriptions) {
      banners.push(<SubscriptionExpiringBanner />)
    }

    // Not important
    if (!hasInteractedWithRqRoadmapBanner) {
      banners.push(<RqRoadmapBanner />)
    }

    return banners
  }

  const banners = getBanners()

  const banner = banners[banners.length - 1]

  return <>{banner}</>
}

export default Banners
